import { TENNIS } from "../constants";
import { getSplitDesc } from "./getSplitDesc";
import { getLocalizedScoreLabel } from "./localizedScoreLabels";

export function parseScore(scr, sportRef) {
    function formatScores(scores) {
        const periodsSet = new Set();
        const formattedScores = [];
        for (let i = 0; i <= 6; i++) {
            if (i <= 4 || (i === 5 && sportRef !== 4) || (i === 6 && sportRef !== 23)) {
                const score = scores[i]?.[`score${i + 1}`];
                if (score?.length > 0) {
                    let scoreObj = null;
                    if (score.includes('#')) {
                        const parts = score.split('#');
                        const p = getLocalizedScoreLabel(sportRef, parts[0].replace(/\s+/g, ''));
                        const s = parts[1];
                        const sep = s.includes(':') ? ':' : '-';
                        const [s1, s2] = s.replace(/\s+/g, '').split(sep);
                        scoreObj = {isTotalScore: false, p: p, s1, s2};
                    } else {
                        const [s1, s2] = score.split(' - ');
                        scoreObj = {isTotalScore: true, p: 'T', s1, s2};
                    }
                    // Avoid duplicates
                    if (!periodsSet.has(scoreObj.p)) {
                        periodsSet.add(scoreObj.p);
                        formattedScores.push(scoreObj);
                    }
                }
            }
        }
        return formattedScores;
    }

    const partialScores = scr?.scps?.map(function(s, i) {
        const key = "score" + (i + 2);
        const parts = s?.split("#");
        let value = parts?.length > 1 && parts[1] && (getLocalizedScoreLabel(sportRef, parts[0].replace(/\s+/g, '')) + '#' + parts[1]);
        // Handle Tennis advantage
        if (sportRef === TENNIS && parts[0] === 'G') {
            const scores = parts[1].split(':');
            const team1Score = parseInt(scores[0], 10), team2Score = parseInt(scores[1], 10);
            if (team1Score === 50) {
                value = `G#A:${team2Score}`;
            } else if (team2Score === 50) {
                value = `G#${team1Score}:A`;
            }
        }
        return {
            [key]: value
        }
    });

    let periodo = (scr?.st)? getLocalizedScoreLabel(sportRef, scr.st) : null;
    // if (scr?.st) {
    //     periodo = getLocalizedStatus(scr.st, xs_languageCode, sportRef);
    // }

    let time = null;
    if (scr?.t != null) {
        const parsed = parseInt(scr.t, 10);
        if (!isNaN(parsed) && parsed > 0) {
            time = `${parsed}'`;
        }
    }

    const score = {
        periodo,
        srv: scr?.srv,
        currentMinute: time,
        combinedScore: '',
        team1Score: null,
        team2Score: null,
        currentScore: [{score1: scr?.sc ?? ''}].concat(partialScores)
    };
    if (scr && scr.sc) {
        try {
            score.combinedScore = scr.sc;
            const [team1Score, team2Score] = getSplitDesc(scr.sc);
            score.team1Score = team1Score;
            score.team2Score = team2Score;
        } catch (e) {}
    }
    score.formattedScores = formatScores(score.currentScore);

    if (sportRef === 4) {
        try {
            let parts = null;
            if (score.currentScore[6] == null) {
                parts = score.currentScore[5].score6.replace("T#", "").split('-');
            } else {
                parts = score.currentScore[6].score7.replace("T#", "").split('-');            
            }
            let team1Score = parts[0];
            let team2Score = parts[1];
            if (team1Score != null && team2Score != null) {
                score.combinedScore = `${team1Score}-${team2Score}`;
            }
        } catch (error) {
                    
        }
    }
    
    score.sourceServing = '';
    score.serviceIconType = null;
    if (sportRef === 5) {
        score.sourceServing = 'assets\\img\\sport\\icone\\pallina_tennis.svg';
        score.serviceIconType = 'service-icon-tennis';
    } else if (sportRef === 20 || sportRef === 23 || sportRef === 34) {
        score.sourceServing = 'assets\\img\\sport\\icone\\service-volley.png';
        score.serviceIconType = 'service-icon-volley';
    }

    return score;
}
